<template>
  <div>
    <div v-if="insightData.length">
      <div id="chart">
        <apexchart type="bar" height="400" :options="chartOptions" :series="series"></apexchart>
      </div>
    </div>
    <div v-else>
      <p v-if="loading">Loading...</p>

      <p v-else>No data available</p>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'pickl-answers',
  components: {
    apexchart: VueApexCharts
  },
  props: ['brandId', 'insightData'],
  data () {
    return {
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          stackType: '100%'
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        xaxis: {
          categories: []
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'right',
          offsetX: 0,
          offsetY: 50
        }
      },
      series: [],
      loading: true // Added loading state
    }
  },
  mounted () {
    this.loading = true
    if (this.insightData) {
      this.updateChartData()
      this.loading = false
    } else {
      this.loading = false // Stop loading if no data is provided
    }
  },
  methods: {
    updateChartData () {
      this.loading = true
      if (this.insightData.length) {
        const ageRanges = Array.from(new Set(this.insightData.map(item => item.age_range)))
        const answerOptions = Array.from(new Set(this.insightData.map(item => item.answer_option)))
        const countsByOption = {}
        // Initialize each answer option with an empty array
        answerOptions.forEach(option => {
          countsByOption[option] = []
        })

        // Populate counts for each age range and answer option
        ageRanges.forEach(ageRange => {
          answerOptions.forEach(option => {
            const data = this.insightData.find(item => item.age_range === ageRange && item.answer_option === option)
            countsByOption[option].push(data ? data.answer_count : 0)
          })
        })

        // Update chart categories and series reactively
        this.$set(this.chartOptions.xaxis, 'categories', ageRanges)
        this.series = answerOptions.map(option => ({
          name: option,
          data: countsByOption[option]
        }))

        // Force a reactivity update by reassigning chartOptions
        this.chartOptions = { ...this.chartOptions }
        this.loading = false
      } else {
        this.loading = false
      }
      // Stop loading after updating the chart
    }
  },
  watch: {
    insightData (newVal) {
      if (newVal) {
        this.updateChartData()
      }
      // } else {
      //   this.loading = false
      // }
    }
  }
}
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 438px;
}
</style>
